import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { StudyReportNavbar } from '../../../../analytics/components/StudyReportNavbar';
import { AnalyticsPageHeader } from '../main/parts/AnalyticsPageHeader';
import { ProjectUsersContent } from './ProjectUsersContent';
import { AnalyticsProjectDomain } from './store/AnalyticsProjectDomain';
import { AnalyticsProjectUI } from './store/AnalyticsProjectUI';

export const AnalyticsProjectPage = observer(() => {
  const { projectId } = useParams<{ projectId: string }>();
  const reportArg = useMemo(() => ({ projectIds: projectId ? [projectId] : [] }), [projectId]);
  const ui = useMemo(() => new AnalyticsProjectUI(new AnalyticsProjectDomain(), projectId), [projectId]);

  useEffect(() => {
    ui.boot();
  }, [ui]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%', height: '100%', minHeight: 0 }}>
      <AnalyticsPageHeader
        breadcrumbs={ui.breadcrumbs.value}
        isFetching={ui.isFetchingProject.value}
        actions={<StudyReportNavbar key={`report-${projectId}`} reportArg={reportArg} />}
      />
      <ProjectUsersContent reportArg={reportArg} />
    </Box>
  );
});
